import React, { Component } from 'react';
import { CssBaseline, Grid, withStyles } from '@material-ui/core';

import { withRouter } from 'react-router-dom';
import PaginationItem from '@material-ui/lab/PaginationItem';
import IconButton from '@material-ui/core/IconButton';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';

const styles = (theme) => ({
  overflowX: 'hidden',
  overflowY: 'auto',
  width: '100%',
  height: 'calc(100vh - 85px)',
  pageNumbers: {
    listStyle: 'none',
    display: 'flex',
    padding: 0,
  },
});

class Pagination extends Component {
  constructor(props) {
    super(props);
    this.state = {
      pageState: 'list',
      notiItems: null,
    };
  }

  render() {
    const { classes, bbsData, currentPage, bbsPerPage } = this.props;

    const pageNumbers = [];

    for (let i = 1; i <= Math.ceil(bbsData.length / bbsPerPage); i++) {
      pageNumbers.push(i);
    }
    const renderPageNumbers = pageNumbers.map((number) => {
      const selected = () => {
        if (number === currentPage) {
          return true;
        } else {
          return false;
        }
      };

      return (
        <PaginationItem
          key={number}
          page={number}
          size="large"
          id={number}
          onClick={this.props.handleClick}
          selected={selected()}
          style={selected() ? { fontWeight: 'bold', color: '#2C5375' } : { fontWeight: 'bold', color: '#555' }}
        />
      );
    });
    return (
      <React.Fragment>
        <CssBaseline />
        <div>
          <Grid container alignItems="center">
            <div onClick={(e) => this.props.changePage(e, 'prev')}>
              <IconButton size="small">
                <ArrowBackIosIcon fontSize="inherit" />
              </IconButton>
            </div>
            <ul className={classes.pageNumbers}>{renderPageNumbers}</ul>
            <div onClick={(e) => this.props.changePage(e, 'next')}>
              <IconButton size="small">
                <ArrowForwardIosIcon fontSize="inherit" />
              </IconButton>
            </div>
          </Grid>
        </div>
      </React.Fragment>
    );
  }
}

export default withRouter(withStyles(styles, { withTheme: true })(Pagination));
